import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Blog() {
  return (
    <>
      <Helmet>
        <title>
          Client Exchange Blog | Lawn Mowing, Pool Care & Cleaning Client Transfers
        </title>

        <meta
          name="description"
          content="Insights, guides and strategies for lawn mowing, pool care and cleaning contractors looking to buy, sell and swap recurring residential clients across Australia."
        />
      </Helmet>

      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "40px 20px",
        }}
      >
        <h1
          style={{
            fontSize: "38px",
            marginBottom: "10px",
            color: "#2e7d32",
          }}
        >
          Client Exchange Blog
        </h1>

        <p
          style={{
            fontSize: "18px",
            lineHeight: "1.7",
            color: "#444",
            marginBottom: "40px",
          }}
        >
          Insights, strategies and industry discussions for lawn mowing,
          pool care and residential cleaning contractors across Australia.
        </p>

        {/* ARTICLE CARD */}

        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "12px",
            padding: "25px",
            marginBottom: "25px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <h2
            style={{
              marginBottom: "15px",
              color: "#2e7d32",
            }}
          >
            Why Contractors Buy, Sell & Swap Residential Clients
          </h2>

          <p
            style={{
              lineHeight: "1.7",
              color: "#555",
              marginBottom: "20px",
            }}
          >
            Discover why lawn mowing, pool care and cleaning contractors
            are using recurring residential client transfers to improve
            route density, reduce travel and work smarter.
          </p>

          <Link
            to="/blog/why-contractors-buy-sell-swap-residential-clients"
            style={{
              display: "inline-block",
              backgroundColor: "#2e7d32",
              color: "#fff",
              padding: "12px 20px",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Read Article
          </Link>
        </div>
        <div
  style={{
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "25px",
    marginBottom: "25px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  }}
>
  <h2
    style={{
      marginBottom: "15px",
      color: "#2e7d32",
    }}
  >
    How Recurring Residential Clients Build Business Value
  </h2>

  <p
    style={{
      lineHeight: "1.7",
      color: "#555",
      marginBottom: "20px",
    }}
  >
    Discover how lawn mowing, pool care and cleaning contractors build
    stronger businesses through recurring residential clients, tighter
    routes, easier access, better parking and improved operational
    efficiency.
  </p>

  <Link
    to="/blog/how-recurring-residential-clients-build-business-value"
    style={{
      display: "inline-block",
      backgroundColor: "#2e7d32",
      color: "#fff",
      padding: "12px 20px",
      borderRadius: "8px",
      textDecoration: "none",
      fontWeight: "bold",
    }}
  >
    Read Article
  </Link>
</div>

<div
  style={{
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "25px",
    marginBottom: "25px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  }}
>
  <h2
    style={{
      marginBottom: "15px",
      color: "#2e7d32",
    }}
  >
    The Hidden Cost of Driving Across Town for Recurring Visits
  </h2>

  <p
    style={{
      lineHeight: "1.7",
      color: "#555",
      marginBottom: "20px",
    }}
  >
    Discover why route density matters, how excessive travel impacts
    profitability, and why buying, selling and swapping recurring
    residential clients can help contractors grow smarter.
  </p>

  <Link
    to="/blog/the-hidden-cost-of-driving-across-town-for-recurring-visits"
    style={{
      display: "inline-block",
      backgroundColor: "#2e7d32",
      color: "#fff",
      padding: "12px 20px",
      borderRadius: "8px",
      textDecoration: "none",
      fontWeight: "bold",
    }}
  >
    Read Article
  </Link>
</div>

<div
  style={{
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "25px",
    marginBottom: "25px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  }}
>
  <h2
    style={{
      marginBottom: "15px",
      color: "#2e7d32",
    }}
  >
    Spring Is Here: Is It Time to Tighten Up Your Mowing Run?
  </h2>

  <p
    style={{
      lineHeight: "1.7",
      color: "#555",
      marginBottom: "20px",
    }}
  >
    Fuel, travel time and vehicle costs can eat into the value of an
    out-of-the-way mowing client. Discover why spring is a good time to
    review your run and build a tighter, more efficient route.
  </p>

  <Link
    to="/blog/spring-tighten-your-mowing-run"
    style={{
      display: "inline-block",
      backgroundColor: "#2e7d32",
      color: "#fff",
      padding: "12px 20px",
      borderRadius: "8px",
      textDecoration: "none",
      fontWeight: "bold",
    }}
  >
    Read Article
  </Link>
</div>
      </div>
      
      
    </>
  );
}